import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-punteggio',
  templateUrl: './punteggio.component.html',
  styleUrls: ['./punteggio.component.scss']
})
export class PunteggioComponent implements OnInit {

  public punteggio;
  public localStorage = localStorage;

  constructor() {
    console.log('ciao')
  }

  ngOnInit(): void {
    this.punteggio = localStorage.getItem('points')
  }

}
